import React from 'react';
import styled from 'styled-components';

import {Row, Column} from './../../common/Layouts/Layouts';
import RatingsBreakup from '../RatingsBreakup/RatingsBreakup';
import {getRatingsColor} from '@stencil/hotels-utils/src/get-ratings-colors';

const GuestReview = ({snapData}) => {
  const {hotelRating = 4, reviewCount = 0, ratingsOnlyCount = 0} = snapData;
  const ratingCount = reviewCount - ratingsOnlyCount;

  return (
    <>
      <GoRatingBlock hotelRating={hotelRating}>
        <GoRatingTextWrapper>goRating</GoRatingTextWrapper>
        <AvgReviewTextWrapperDiv
        // itemprop="aggregateRating"
        // itemScope
        // itemType="http://schema.org/AggregateRating"
        >
          {/* <meta content="1" itemProp="worstRating" /> */}
          <AvgReviewTextWrapper>{hotelRating}</AvgReviewTextWrapper>
          <TotalReviewTextWrapper
          // itemProp="bestRating"
          >
            /5
          </TotalReviewTextWrapper>
        </AvgReviewTextWrapperDiv>
        <ReviewCountTextWrapper>{reviewCount} Ratings</ReviewCountTextWrapper>
        <RatingsCountTextWrapper
        // itemProp="reviewCount" content={ratingCount}
        >
          {ratingCount} Reviews
        </RatingsCountTextWrapper>
      </GoRatingBlock>
      <RatingsBreakup rwc={snapData.rwc} />
    </>
  );
};

export default GuestReview;

const GoRatingBlock = styled(Column)(props => {
  return `
    background-color: ${getRatingsColor(props.hotelRating)};
    align-items: center;
    justify-content: center;
    width: 14.5rem;
    color: ${props.theme.colors.goWhite.base};
    border-radius: ${props.theme.misc.borderRadius.large};
  `;
});

const GoRatingTextWrapper = styled.p(
  props => `
  font-size: ${props.theme.font.custom(22)};
  align-items: center;
  padding-top: ${props.theme.spacing.base};
  padding-bottom: ${props.theme.spacing.small};
`,
);

const ReviewCountTextWrapper = styled.p(
  props => `
  font-size: ${props.theme.font.custom(14)};
  align-items: center;
  padding-top: ${props.theme.spacing.small};
  padding-bottom: ${props.theme.spacing.small};
`,
);

const RatingsCountTextWrapper = styled(Column)(
  props => `
  font-size: ${props.theme.font.custom(14)};
  align-items: center;
  padding-bottom: ${props.theme.spacing.base};
`,
);

const AvgReviewTextWrapperDiv = styled.p(
  props => `
  flex-direction: row;
  align-items: flex-end;
`,
);

const AvgReviewTextWrapper = styled.span(
  props => `
  // color: ${props.theme.colors.goGreen.base};
  font-size: 3.8rem;
  align-items: center;
  font-weight: bold;
`,
);

const TotalReviewTextWrapper = styled.span(
  props => `
  font-size: 2.6rem;
  align-items: center;
  line-height: 1.1;
  font-weight: bold;
`,
);
